import React, { useEffect, useState } from 'react';
import { PriceSchedule, Zone } from 'store/zone/reducer';
import SubHeader from 'components/SubHeader';
import Main from 'components/Main';
import DateBlock from 'components/ZoneSchema';
import {
  DateObject,
  ZoneSchemaContainer,
} from 'components/ZoneSchema/contants';
import { useSelector } from 'react-redux';
import { selectCurrentFacility, selectCurrentZones } from 'store/zone/selector';
import Button, { ButtonColors } from 'components/input/Button';
import useModalStack from 'components/Modal/useModalStack';
import AddZoneScheduleModal from './AddZoneScheduleModal';
import { hasEditRights } from 'store/uiSettings/selectors';
import Toggle from 'components/input/Toggle';
import styled from 'styled-components';
import Label from 'components/input/Label';
import { FaDownload } from 'react-icons/fa';
import { PriceV3Api } from 'constants/api-fetch';
import IconButton from 'components/input/IconButton';
import { ImSpinner2 } from 'react-icons/im'; // spinner-ikon

const ButtonWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  .export-button {
    height: 40px;
    width: 40px;
    padding: 0;
    padding: 0px 0 3px 1px;
    margin-bottom: -0.7em;
  }
`;

const ToggleWrapper = styled.div`
  padding-top: 24px;
  gap: 10px;
  align-items: center;
  display: flex;
`;
const ToggleTitle = styled.div``;

const ScheduleComponent: React.FC = () => {
  const selZones = useSelector(selectCurrentZones);
  const facilityId = useSelector(selectCurrentFacility)?.id!;
  const [zones, setZones] = useState<Zone[]>(selZones);
  const [loading, setLoading] = useState(false);
  const canEdit = useSelector(hasEditRights);
  const modal = useModalStack();
  const [multipleEdit, setMultipleEdit] = useState(false);
  const apiHandler: PriceV3Api | null = new PriceV3Api();
  const [exportLoading, setExportLoading] = useState(false);

  const [selectedSelectBlock, setSelectedSelectBlock] = useState<{
    [key: string]: string;
  }>(
    zones.reduce((acc, curr) => {
      var lsch = curr.schedules.reduce((_acc, _curr) => {
        if (!_curr.liveActivationTimeStamp) return _acc;
        if (
          !_acc.liveActivationTimeStamp ||
          _curr.liveActivationTimeStamp > _acc.liveActivationTimeStamp
        ) {
          _acc = _curr;
        }
        return _acc;
      }, {} as PriceSchedule);
      acc[curr.gid] = lsch.gid;
      return acc;
    }, {} as { [key: string]: string })
  );

  let zoneSchedules = zones.map((zn) => {
    const maxPrevTime = zn.schedules.reduce(
      (cur, sch) => Math.max(cur, sch.previewActivationTimeStamp ?? 0),
      -1
    );
    const maxLiveTime = zn.schedules.reduce(
      (cur, sch) =>
        !sch.liveActivationTimeStamp
          ? cur
          : Math.max(cur, sch.liveActivationTimeStamp ?? 0),
      -1
    );

    const liveSchedule = zn.schedules.reduce((acc, curr) => {
      if (!curr.liveActivationTimeStamp) return acc;
      if (
        curr &&
        (!acc ||
          !acc.liveActivationTimeStamp ||
          curr.liveActivationTimeStamp > acc.liveActivationTimeStamp)
      ) {
        acc = curr;
      }
      return acc;
    }, null as PriceSchedule | null);

    const previewSchedule = zn.schedules.reduce((acc, curr) => {
      if (!curr.previewActivationTimeStamp) return acc;
      if (
        !acc.previewActivationTimeStamp ||
        curr.previewActivationTimeStamp > acc.previewActivationTimeStamp
      ) {
        acc = curr;
      }
      return acc;
    }, {} as PriceSchedule);

    var activeSchedule =
      zn.schedules.find((f) => f.gid === selectedSelectBlock[zn.gid]) ??
      previewSchedule;

    const activations = activeSchedule?.priceActivations.map((pa, idx) => {
      const pri = activeSchedule.pricings.find((pri) => pri.id === pa.priceID)!;
      return {
        id: `${pri.id}_${idx}`,
        from: new Date(pa.fromDate),
        to: new Date(pa.toDate),
        priceProduct: pri,
        index: idx,
      } as DateObject;
    });

    return {
      title: zn.name,
      zone: zn,
      isLive: activeSchedule.gid === liveSchedule?.gid,
      schemaGID: activeSchedule.gid,
      previewSchemaGID: previewSchedule.gid,
      liveSchemaGID:
        liveSchedule?.gid ?? '00000000-0000-0000-0000-000000000000',
      alternativeSchemas: zn.schedules.map((sch) => ({
        name: sch.name,
        gid: sch.gid,
      })),
      dateList: activations ?? [],
    } as ZoneSchemaContainer;
  });

  //useSelector((root:ApplicationState)=>root.zoneData[0].schedules

  if (selZones.length === 1) {
    var scheduleItem = selZones[0];
    var previewScheduel = scheduleItem.schedules.reduce((acc, curr) => {
      if (!curr.previewActivationTimeStamp) return acc;
      if (
        !acc.previewActivationTimeStamp ||
        curr.previewActivationTimeStamp > acc.previewActivationTimeStamp
      ) {
        acc = curr;
      }
      return acc;
    }, {} as PriceSchedule);

    var liveSchedule = scheduleItem.schedules.reduce((acc, curr) => {
      if (!curr.liveActivationTimeStamp) return acc;
      if (
        !acc.liveActivationTimeStamp ||
        curr.liveActivationTimeStamp > acc.liveActivationTimeStamp
      ) {
        acc = curr;
      }
      return acc;
    }, {} as PriceSchedule);

    zoneSchedules = scheduleItem.schedules.reduce((acc, curr) => {
      const activation = curr.priceActivations.map((pa, idx) => {
        const pri = curr.pricings.find((pri) => pri.id === pa.priceID)!;
        return {
          id: `${pri.id}_${idx}`,
          from: new Date(pa.fromDate),
          to: new Date(pa.toDate),
          priceProduct: pri,
          index: idx,
        } as DateObject;
      });

      acc.push({
        ...zoneSchedules[0],
        title: curr.name,
        isLive: liveSchedule.gid === curr.gid,
        schemaGID: curr.gid,
        previewSchemaGID: previewScheduel.gid === curr.gid ? curr.gid : '',
        liveSchemaGID: liveSchedule.gid,
        dateList: activation ?? [],
      });
      return acc;
    }, [] as ZoneSchemaContainer[]);
  }

  let title = 'Schedule';
  if (selZones.length === 1) {
    title = `Schedule - ${selZones[0].name}`;
  }

  useEffect(() => {
    setLoading(true);
    setZones(selZones);
    if (selZones.length > 1 && multipleEdit) {
      setMultipleEdit(false);
    }
    setTimeout(() => {
      setLoading(false);
    }, 0);
  }, [selZones]);

  function getFileNameFromDisposition(cd?: string | null) {
    if (!cd) return null;
    // RFC 5987 (filename*):
    const mStar = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (mStar) return decodeURIComponent(mStar[1]);
    // filename="..."
    const mQuoted = cd.match(/filename\s*=\s*"([^"]+)"/i);
    if (mQuoted) return mQuoted[1];
    // filename=plain
    const mPlain = cd.match(/filename\s*=\s*([^;]+)/i);
    if (mPlain) return mPlain[1].trim();
    return null;
  }

  const exportPrices = async () => {
    setExportLoading(true);
    var res = await apiHandler.makePostWithFile(
      `price/export`,
      JSON.stringify({
        FacilityId: facilityId,
        ZoneIds: zones.map((z) => z.id),
      }),
      {}
    );
    if (!res.ok) {
      // Om backend skickar fel som text/json
      const msg = await res.text();
      throw new Error(`Export failed: ${msg}`);
    }
    const cd = res.headers.get('Content-Disposition');
    const filename = getFileNameFromDisposition(cd) ?? 'prices.xlsx';
    const blob = await res.blob();

    if (blob.type.includes('application/json')) {
      const text = await blob.text();
      throw new Error(`Export returned JSON instead of file: ${text}`);
    }

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    setExportLoading(false);
  };

  return (
    <Main>
      <SubHeader
        className="schedule-header"
        buttons={
          <ButtonWrapper>
            {!canEdit || zones.length !== 1 ? undefined : (
              <>
                <ToggleWrapper>
                  <ToggleTitle>Edit multiple pricings:</ToggleTitle>
                  <Toggle
                    checked={multipleEdit}
                    onChange={(value) => setMultipleEdit(!multipleEdit)}
                  />
                </ToggleWrapper>
                <Button
                  color={ButtonColors.add}
                  onClick={() => {
                    modal.push(<AddZoneScheduleModal />);
                  }}
                >
                  Add zone schedule
                </Button>
              </>
            )}
            <Button
              disabled={exportLoading}
              className="export-button"
              onClick={() => {
                exportPrices();
              }}
              title="Export to excel"
            >
              {exportLoading && <ImSpinner2 className="icon" size={20} />}
              {!exportLoading && <FaDownload className="icon" size={20} />}
            </Button>
          </ButtonWrapper>
        }
      >
        {title}
      </SubHeader>
      <DateBlock
        multipleEdit={multipleEdit}
        toggleMultipleEdit={() => setMultipleEdit(!multipleEdit)}
        onSelectChange={(zoneGid, scheduleGid) => {
          setSelectedSelectBlock({
            ...selectedSelectBlock,
            [zoneGid]: scheduleGid,
          });
        }}
        blockLists={loading ? [] : zoneSchedules}
        zones={zones}
      />
    </Main>
  );
};

export default ScheduleComponent;
